import React from 'react';
import { Paper, Box, Typography, Chip } from '@mui/material';
import { RoadmapItem } from '../../types';
import IssueCard from '../IssueCard/IssueCard';

interface RoadmapColumnProps {
    title: string;
    items: RoadmapItem[];
    chipColor: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    onItemClick: (item: RoadmapItem) => void;
}

const RoadmapColumn: React.FC<RoadmapColumnProps> = ({
    title,
    items,
    chipColor,
    onItemClick
}) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 2.5,
                borderRadius: 3,
                height: 'fit-content',
                minHeight: '200px'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h5" component="h2" sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
                    {title}
                </Typography>
                <Chip
                    label={items.length}
                    size="small"
                    sx={{ ml: 'auto', minWidth: '28px' }}
                    color={chipColor}
                />
            </Box>

            {items.map(item => (
                <IssueCard
                    key={item.id}
                    item={item}
                    onClick={onItemClick}
                />
            ))}

            {items.length === 0 && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontStyle: 'italic', textAlign: 'center', py: 3 }}
                >
                    No {title.toLowerCase()} tasks
                </Typography>
            )}
        </Paper>
    );
};

export default RoadmapColumn;
